<template>
  <div id="monthCardMain">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>月车</el-breadcrumb-item>
          <el-breadcrumb-item>月卡数据查询</el-breadcrumb-item>
          <el-breadcrumb-item>月卡数据</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row>
      <el-form :inline="true"
               class="pageSearch">
        <el-form-item label="客户名称::">
          <el-select v-model="selCustID"
                     filterable
                     clearable
                     @change="changeCust"
                     placeholder="请选择客户">
            <el-option v-for="item in choiceCusts"
                       :key="item.fCustID"
                       :label="item.unionName"
                       :value="item.fCustID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="月卡分组::">
          <el-select v-model="selfGroupID"
                     placeholder="请选择分组"
                     clearable
                     filterable>
            <el-option v-for="item in choiceGroups"
                       :key="item.fGroupID"
                       :label="item.fGroupName"
                       :value="item.fGroupID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="有效期限::">
          <el-select v-model="expirationDay"
                     placeholder="请选择剩余有效期限"
                     clearable
                     filterable>
            <el-option v-for="item in expirationDays"
                       :key="item.value"
                           :label="item.label"
                           :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关键字::">
          <el-input placeholder="请输入卡号/车牌/用户姓名/电话/单位"
                    v-model="searchKeyWord"
                    class="input-with-select">
          </el-input>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-form :inline="true"
               class="pageSearch">
        <el-form-item label="开始时间::">
              <el-date-picker v-model="startTime"
                              style="width:200px"
                              type="datetime"
                              :clearable="true"
                              format="yyyy-MM-dd HH:mm:ss"
                              placeholder="选择开始时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间::">
              <el-date-picker v-model="endTime"
                              style="width:200px"
                              :clearable="true"
                              format="yyyy-MM-dd HH:mm:ss"
                              type="datetime"
                              placeholder="选择结束时间">
              </el-date-picker>
            </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     size="small"
                     @click="cardQuery">查询</el-button>
          <el-button type="success"
                     size="small"
                     icon="el-icon-share"
                     :loading="export_loading"
                     v-if="is_export"
                     @click="exportData">{{export_msg}}</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-table :data="cardList"
                      border
                      v-loading="loading"
                      highlight-current-row
                      style="width: 100%"
                      :height="tableHeight"
                      ref="singleTable">
              <el-table-column type="index"
                               width="50"
                               label="序号"
                               :index="indexMethod">
              </el-table-column>
              <el-table-column prop="fCreateTimeName"
                               width="180"
                               label="创建时间">
              </el-table-column>
              <!--<el-table-column prop="fOpLastTimeName"
                               width="180"
                               label="最后同步时间">
              </el-table-column>-->
              <el-table-column prop="fCustNo"
                               width="80"
                               label="客户编号">
              </el-table-column>
              <el-table-column prop="custName"
                               width="200"
                               label="客户名称">
              </el-table-column>
              <el-table-column prop="fCardNo"
                               width="80"
                               label="卡号">
              </el-table-column>
              <el-table-column prop="fGroupName"
                               width="80"
                               label="分组名称">
              </el-table-column>
              <!--<el-table-column-->
              <!--prop="fCustName"-->
              <!--width="80"-->
              <!--label="用户姓名">-->
              <!--</el-table-column>-->
              <!--<el-table-column-->
              <!--prop="fCustPhone"-->
              <!--label="用户电话">-->
              <!--</el-table-column>-->
              <el-table-column prop="fCustName"
                               label="用户姓名">
              </el-table-column>
              <el-table-column prop="fPlateList"
                               width="150"
                               label="车牌号码">
              </el-table-column>
              <el-table-column prop="fPlaceNums"
                               align="right"
                               width="80"
                               label="车位数量">
              </el-table-column>
              <el-table-column prop="fCardTypeName"
                               width="80"
                               label="月卡类型">
              </el-table-column>
              <el-table-column prop="fAmount"
                               align="right"
                               label="包月金额">
              </el-table-column>
              <el-table-column prop="fStartTime"
                               width="150"
                               label="起始时间">
              </el-table-column>
              <el-table-column prop="fEndTime"
                               width="150"
                               label="结束时间">
              </el-table-column>
              <el-table-column prop="fCommRateName"
                               width="90"
                               label="普通日费率">
              </el-table-column>
              <el-table-column prop="fHoliRateName"
                               width="90"
                               label="节假日费率">
              </el-table-column>
              <!--<el-table-column prop="fCustInfo"
                               label="用户单位">
              </el-table-column>
              <el-table-column prop="fStopPlace"
                               label="停放位置">
              </el-table-column>
              <el-table-column prop="fRoomNo"
                               label="房间号">
              </el-table-column>-->
              <el-table-column prop="fRemark"
                               label="备注">
              </el-table-column>
            </el-table>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination background
                         @size-change="handleSizeChange"
                         :current-page.sync="pageNo"
                         @current-change="handlePage"
                         :page-size="pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="total"
                         v-if="total>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'monthCardMain',
  data () {
    return {
      is_export: false,
      export_msg: '导出',
      export_loading: false,
      loading: false,
      searchKeyWord: '',
      expirationDay: '',
      tableHeight: 0,
      choiceCusts: [],
      offlineCusts: [],
      choiceGroups: [],
      cardList: [],
      selCustID: '',
      selfGroupID: '',
      pageSize: 20,
      pageNo: 1,
      total: 0,
      fStartTime: '',
      fEndTime: '',
      startTime: '',
      endTime: '',
      expirationDays: [{ value: '0', label: '所有月卡' }, { value: '7', label: '7天过期' }, { value: '15', label: '15天过期' }, { value: '30', label: '30天过期' }, { value: '-1', label: '过期月卡' }]
    }
  },
  methods: {
    ...mapActions([
      'getCardGroupByCustId', 'getCustByGroup', 'getMonthCardListAsync', 'getCurrentUserPers', 'exportMonthCardData'
    ]),
    exportData () {
      if ((this.selCustID || '').trim().length <= 0) {
        this.$message.error('提示：请先选择客户')
        return false
      }
      this.export_loading = true
      this.export_msg = '导出中……'
      var custArr = (this.choiceCusts || []).filter((item) => {
        return item.fCustID === this.selCustID
      })
      var fileName = custArr.length > 0 ? custArr[0].unionName : ''
      if (this.expirationDay === '0') {
        fileName = fileName + '_所有月卡'
      }
      if (this.expirationDay === '7') {
        fileName = fileName + '_7天过期'
      }
      if (this.expirationDay === '15') {
        fileName = fileName + '_15天过期'
      }
      if (this.expirationDay === '30') {
        fileName = fileName + '_30天过期'
      }
      if (this.expirationDay === '-1') {
        fileName = fileName + '_过期月卡'
      }
      this.exportMonthCardData({
        fCustID: this.selCustID,
        fGroupID: this.selfGroupID,
        pageSize: this.pageSize,
        pageNo: this.pageNo,
        searchKeyWord: this.searchKeyWord,
        expirationDay: this.expirationDay,
        fStartTime: this.fStartTime,
        fEndTime: this.fEndTime
      }).then(res => {
        this.export_loading = false
        this.export_msg = '导出'
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.fileDownload(data.Data, fileName + '_月卡数据.xls')
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    tabClick () {
      this.pageNo = 1
      this.total = 0
      this.initData()
    },
    cardQuery () {
      if ((this.selCustID || '').trim().length <= 0) {
        this.$message.error('提示：请先选择客户')
        return false
      }
      this.initData()
      // let obj = {}
      // obj = this.choiceCusts.find((item) => {
      //   return item.fCustID === this.selCustID
      // })
      // this.custName = obj.unionName
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 25 - 230
      obj.tableHeight = clientHeight
    },
    init () {
      var today = new Date()
      this.startTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0)
      this.endTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59)
    },
    indexMethod (index) {
      return this.pageSize * (this.pageNo - 1) + index + 1
    },
    handleSizeChange (value) {
      this.pageSize = value
      this.initData()
    },
    handlePage (index) {
      this.pageNo = index
      this.initData()
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.fIsDel === '1') {
        return 'warning-row'
      }
      return ''
    },
    tableErrorRowClassName ({ row, rowIndex }) {
      if (row.fIsErr) {
        return 'error-row'
      }
      return ''
    },
    initData () {
      this.fStartTime = ''
      if ((this.startTime || '').toString().trim().length > 0) {
        this.fStartTime = this.$dateFormat(this.startTime, 'yyyy-MM-dd hh:mm:ss')
      }
      this.fEndTime = ''
      if ((this.endTime || '').toString().trim().length > 0) {
        this.fEndTime = this.$dateFormat(this.endTime, 'yyyy-MM-dd hh:mm:ss')
      }
      this.cardList = []
      this.loading = true
      this.getMonthCardListAsync({
        fCustID: this.selCustID,
        fGroupID: this.selfGroupID,
        pageSize: this.pageSize,
        pageNo: this.pageNo,
        searchKeyWord: this.searchKeyWord,
        expirationDay: this.expirationDay,
        fStartTime: this.fStartTime,
        fEndTime: this.fEndTime
      }).then(res => {
        this.loading = false
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.total = data.Data.total
              this.cardList = data.Data.rows
            } else {
              this.$message.error(data.Msg)
            }
          }
        }
      })
    },
    changeCust (fCustID) {
      this.selfGroupID = ''
      this.choiceGroups = []
      this.getCardGroupByCustId({ fCustID: fCustID }).then(res => {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            let tmpGroups = []
            Object.assign(tmpGroups, data.Data)
            this.choiceGroups = tmpGroups
          }
        }
      })
    }
  },

  watch: {

  },
  computed: {
    ispagination: function () {
      return this.total > this.pageSize
    }
  },
  created () {
    this.getCurrentUserPers({ perTypeId: 26500 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_export = data.Data.data.is_export
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    let sizethis = this
    window.onresize = () => {
      this.setTableHeight(sizethis)
    }
    this.getCustByGroup().then(res => {
      if (res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            let custs = []
            Object.assign(custs, data.Data)
            this.choiceCusts = custs
            if (this.choiceCusts && this.choiceCusts.length === 1) {
              this.selCustID = this.choiceCusts[0].fCustID
              this.changeCust(this.selCustID)
            }
            this.offlineCusts = custs.filter(r => r.fCustTypeID === '0') // 封闭式客户
          }
        }
      }
    })
    this.init()
    // this.initData()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>

<style>
#monthCardMain .is-disabled .el-input__inner,
#monthCardMain .is-disabled .el-textarea__inner {
  color: #606266;
}
#monthCardMain .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
#monthCardMain .el-dialog__title {
  color: white;
}
#monthCardMain .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
#monthCardMain .el-dialog__body {
  padding: 5px;
}
#monthCardMain .warning-row {
  color: chocolate;
}
#monthCardMain .el-table__row {
  height: 36px;
}
#monthCardMain .error-row {
  color: #fb4545;
}
</style>
<style scoped>
.myCardLableClass .isRed {
  color: #fb4545;
}
.pageSearch .el-form-item {
  margin-bottom: 5px;
}
.curRowInfo {
  margin-top: 10px;
}
.curRowInfo .el-row {
  margin-top: 10px;
}
.dialog-video-wrapper .el-dialog__body {
  padding: 5px;
}
.myel-input__inner {
  height: 20px;
  line-height: 20px;
}
legend {
  display: block;
  width: 100%;
  padding: 0;
  margin-bottom: 10px;
  line-height: inherit;
  color: #333;
  border: 0;
  border-bottom: 1px solid #e5e5e5;
}
fieldset {
  margin: 0 2px;
  border: 0px solid silver;
}
.el-upload__tip {
  margin-top: 0px;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/view/card/monthCardMain.vue